import firebase from '../../firebase-integration';
import { contacts } from '../../contants/contacts';

const db = firebase.firestore();

export const emailSupport = (formValues: any) => {
  return db
    .collection('mail')
    .add({
      to: contacts.support,
      message: {
        subject: `Support Request from ${formValues.username}`,
        text: formValues.comments,
      },
    });
};
